// Module
var code = `<div class="log-viewer-backdrop"></div>
<div class="log-viewer-panel">
  <div class="log-viewer-header">
    <span class="log-viewer-title">Live Service Logs</span>
    <div class="header-actions">
      <span id="tail-status" class="tail-status">Ready</span>
      <span id="tail-timer" class="tail-timer hidden"></span>
      <span id="log-count" class="log-count">0 logs</span>
      <button id="close-btn" class="btn btn-icon" title="Close log viewer">✕</button>
    </div>
  </div>

  <div class="log-viewer-body">
    <div class="log-viewer-sidebar">
      <!-- Service Selection -->
      <div class="sidebar-section">
        <div class="section-title">
          <span>Services</span>
          <div class="section-actions">
            <button id="service-show-all-btn" class="link-btn" title="Select all services">Select all</button>
            <button id="service-refresh-btn" class="link-btn" title="Refresh available services">⟳</button>
          </div>
        </div>
        <input type="text" id="service-search" class="service-search-input" placeholder="Filter services..." autocomplete="off" spellcheck="false" />
        <div id="service-token-pills" class="service-token-pills hidden"></div>
        <div id="service-token-suggestions" class="service-token-suggestions hidden"></div>
        <div id="service-list" class="service-list"></div>
      </div>
    </div>

    <div class="log-viewer-results">
      <div class="results-bar">
        <span id="status-bar" class="status-bar">Loading services...</span>
        <div id="prefetch-progress" class="prefetch-progress hidden">
          <span id="prefetch-progress-text" class="prefetch-progress-text">Prefetching logs...</span>
          <div class="prefetch-progress-track">
            <div id="prefetch-progress-fill" class="prefetch-progress-fill"></div>
          </div>
        </div>
      </div>
      <div class="tail-bar">
        <label class="tail-bar-label">Duration (min)</label>
        <input type="number" id="tail-duration" min="1" max="5" step="1" value="5" class="tail-duration-input" />
        <button id="tail-start-btn" class="btn btn-primary" disabled>Start</button>
        <button id="tail-stop-btn" class="btn btn-secondary hidden">Stop Tail</button>
        <button id="tail-reset-btn" class="btn btn-secondary hidden">Reset</button>
        <div class="tail-bar-divider"></div>
        <span id="cache-size" class="cache-size">0 MB</span>
        <button id="cache-clear-btn" class="btn btn-secondary">Clear Cache</button>
        <button id="export-csv-btn" class="btn btn-secondary" disabled title="Stop tail to enable export">Export CSV</button>
        <button id="tooltip-toggle-btn" class="btn btn-secondary" type="button" aria-pressed="true" title="Disable message tooltip popup">Tooltip: On</button>
        <label class="tail-bar-label" for="message-search">Message</label>
        <input type="text" id="message-search" class="message-search-input" placeholder="Search message text..." autocomplete="off" spellcheck="false" />
      </div>
      <div class="history-bar" id="history-bar">
        <label class="tail-bar-label">Fetch history:</label>
        <div class="history-mode-toggle">
          <button id="history-mode-lines" class="toggle-btn active" type="button">Lines</button>
          <button id="history-mode-time" class="toggle-btn" type="button">Time</button>
          <button id="history-mode-full" class="toggle-btn" type="button">Full</button>
        </div>
        <select id="history-lines-select" class="history-select">
          <option value="1000" selected>1,000 lines</option>
          <option value="5000">5,000 lines</option>
          <option value="10000">10,000 lines</option>
        </select>
        <div id="history-time-range" class="history-time-range hidden">
          <label class="tail-bar-label" for="history-begin-input">From</label>
          <input type="datetime-local" id="history-begin-input" class="history-datetime" step="1" />
          <label class="tail-bar-label" for="history-end-input">To</label>
          <input type="datetime-local" id="history-end-input" class="history-datetime" step="1" />
        </div>
        <span id="history-full-hint" class="history-full-hint hidden">Streams the entire log straight to a file (no time range).</span>
        <label class="tail-bar-label">Instance:</label>
        <select id="history-instance-select" class="history-select history-instance-select" disabled>
          <option value="">Current (running)</option>
        </select>
        <button id="history-fetch-btn" class="btn btn-secondary" disabled>Fetch</button>
        <button id="history-download-btn" class="btn btn-secondary hidden" disabled title="Select an instance to download its full log">Download full log</button>
        <span id="history-status" class="history-status"></span>
      </div>
      <div id="table-target" class="slick-container alpine-theme"></div>
    </div>
  </div>
</div>
`;
// Exports
export default code;